var MDB = window.MDB || {};
MDB.DPN = MDB.DPN || {};
MDB.DPN.Offers = MDB.DPN.Offers || {};
MDB.DPN.Offers.Settings = MDB.DPN.Offers.Settings || {};

(function(){
    var _state = {
        $discountPeriodSettingsWrapper: undefined,
        $discountPeriodSettingsToggle: undefined,
        $discountPeriodSettingsEditors: undefined,
        $loadingDiv: undefined,
        $addEditorButton: undefined
    }
    
    function onSettingsEditorToggled(){
        //Detaching our field should prevent it from being posted (and thus being validated)
        if(this.checked){
            _state.$discountPeriodSettingsWrapper.reAttach();
        } else {
            _state.$discountPeriodSettingsWrapper.detach();
        }
        // _state.$discountPeriodSettingsWrapper.toggleClass('hidden', !this.checked);
    }

    function initNewSettingsEditor(context){
        moveIndexFieldIntoTable(context);
        initNumericEditors(context);
        
        context.find('select').each(function(){
            var $el = $(this)
                , fieldName = $el.attr('name').split('.');
            
            //Only the part after the final '.' represents are actual fieldName
            fieldName = fieldName[fieldName.length - 1];

            //Copy the options of the first encountered editor
            var options = _state.$discountPeriodSettingsWrapper.find('select[name$="' + fieldName + '"]:first option').clone();
            
            //Remove the 'selected' attribute to prevent pre-selection of the initial value of our first encountered dropdown
            options.attr('selected', null);
            
            $el.append(options);
        });
    }
    
    function moveIndexFieldIntoTable(context){
        //Move our 'index' field into the first td to ensure valid HTML
        //the index field is something we don't have full control over, it's added by a library
        context.find('[name$="index"]').each(function(){
            var $this = $(this);
            $this.appendTo($this.parent().find('td:first'));
        });
    }
    
    function initNumericEditors(context){
        var numericInputs = context.find('.mdb-numeric-field');
        numericInputs.mdbNumericInput();

        numericInputs.filter('[data-original-value]').each(function(){
            //Workaround to prevent data from getting lost after a failed form submit/page reload with submit via F5
            $(this).data('mdbNumericInput').value(this.dataset['originalValue']);
        });
    }

    function startLoading(){
        //Prevent clicking button multiple times
        _state.$addEditorButton.attr('disabled', true);
        _state.$loadingDiv.appendTo(_state.$discountPeriodSettingsEditors);
    }

    function finishLoading(){
        //Allow add a next editor
        _state.$addEditorButton.attr('disabled', false);
        _state.$loadingDiv.detach();
    }
    
    function withReAttach($el){
        var parent = $el.parent();
        $el.reAttach = function(){
            $el.appendTo(parent);
        }
    }
    
    MDB.DPN.Offers.Settings.initDiscountPeriodSettings = function(){
        _state.$discountPeriodSettingsWrapper = $('#discount-period-settings-wrapper');
        _state.$discountPeriodSettingsToggle = $('#discount-period-settings-toggle');
        _state.$discountPeriodSettingsEditors = _state.$discountPeriodSettingsWrapper.find('.data-collection');
        _state.$loadingDiv = $('<tr> <td colspan="7" style="height: 50px;"> <div class="loading position-relative"></div> </td> </tr>');
        _state.$addEditorButton = _state.$discountPeriodSettingsWrapper.find('.data-collection-add .btn-add');

        withReAttach(_state.$discountPeriodSettingsWrapper);
        
        MDB.Collections.setupFormCollections(_state.$discountPeriodSettingsWrapper);

        //Prevent the first two discount settings periods from being deleted
        _state.$discountPeriodSettingsWrapper.find('.data-collection-remove:lt(2)').parent().html('&nbsp;');
        
        initNumericEditors(_state.$discountPeriodSettingsWrapper);
        moveIndexFieldIntoTable(_state.$discountPeriodSettingsWrapper);
        
        _state.$discountPeriodSettingsWrapper.on('collection-added', function(e, html) { initNewSettingsEditor($(html)); });
        _state.$discountPeriodSettingsWrapper.on('collection-add-start', function() { startLoading(); });
        _state.$discountPeriodSettingsWrapper.on('collection-add-done', function() { finishLoading(); });
        
        //Switches are initialized on container basis
        MDB.initBootstrapSwitches(
            _state.$discountPeriodSettingsToggle.parent(), 
            onSettingsEditorToggled, 
            onSettingsEditorToggled
        );
    }
})();